const NAMESPACE = "navPrograms";

const KEYS = {
    favoritesHeaderText: "favoritesHeaderText",
    recentsHeaderText: "recentsHeaderText",
    registerProgramsButtonLabel: "registerProgramsButtonLabel",
    allProgramsHeaderText: "allProgramsHeaderText",
    closeProgramSelectorLabel: "closeProgramSelectorLabel",
    agencyLogoImageLabel: "agencyLogoImageLabel"
};

const MESSAGES = {
    [KEYS.favoritesHeaderText]: {
        value: "Favorites",
        comment: "Header for section that displays the programs the user has marked as favorites."
    },
    [KEYS.recentsHeaderText]: {
        value: "Recently visited",
        comment: "Header for section that displays the programs the user has most recently visited."
    },
    [KEYS.registerProgramsButtonLabel]: {
        value: "Register for programs",
        comment: "Label for button that opens the page where the user registers for programs."
    },
    [KEYS.allProgramsHeaderText]: {
        value: "All programs",
        comment: "Header for section that displays all programs."
    },
    [KEYS.closeProgramSelectorLabel]: {
        value: "Close program selector dialog",
        comment: "Aria-Label for close button in program selector dialog."
    },
    [KEYS.agencyLogoImageLabel]: {
        value: "{agency} logo image",
        comment: "Aria-Label for Agency logos."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
